<template>
  <div>
    <el-dialog title="其他广告记录" :visible.sync="dialogVisible" width="1100px">
      <div class="filter-grid">
        <el-select v-model="queryForm.ad_type" clearable size="small" placeholder="广告类型">
          <el-option label="Banner" value="1" />
          <el-option label="信息流" value="2" />
          <el-option label="插屏" value="3" />
          <el-option label="开屏" value="4" />
        </el-select>
        <el-date-picker
          v-model="timeRange"
          type="datetimerange"
          size="small"
          value-format="timestamp"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @change="handleTimeChange"
        />
        <div class="filter-actions">
          <el-button type="primary" size="small" @click="search">查询</el-button>
          <el-button size="small" @click="resetSearch">重置</el-button>
        </div>
      </div>

      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" label="记录ID" width="90" align="center" />
        <el-table-column prop="user_id" label="用户ID" width="100" align="center" />
        <el-table-column prop="app_name" label="APP" min-width="140" align="center" />
        <el-table-column prop="channel_name" label="渠道" min-width="140" align="center" />
        <el-table-column prop="ad_id" label="广告ID" min-width="180" align="center" />
        <el-table-column prop="ad_type_label" label="广告类型" width="110" align="center" />
        <el-table-column label="ECPM" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatNumber(row.ecpm) }}
          </template>
        </el-table-column>
        <el-table-column label="上报时间" min-width="160" align="center">
          <template slot-scope="{ row }">
            {{ formatTime(row.created_time) }}
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="paginationForm.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="paginationForm.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
function createDefaultQueryForm() {
  return {
    user_id: "",
    ad_type: "",
    start_time: "",
    end_time: "",
  };
}

export default {
  data() {
    return {
      list: [],
      dialogVisible: false,
      loading: false,
      timeRange: [],
      total: 0,
      queryForm: createDefaultQueryForm(),
      paginationForm: {
        page: 1,
        page_size: 20,
      },
      pageCursorMap: {
        1: 0,
      },
      fetchedPageMap: {},
      hasMore: true,
    };
  },
  methods: {
    formatNumber(value) {
      const num = Number(value || 0);
      return Number.isFinite(num) ? num.toFixed(2) : "--";
    },
    formatTime(value) {
      return value ? this.$fnc.getTimeFormat(value, "ymdhms") : "--";
    },
    resetCursorState() {
      this.pageCursorMap = { 1: 0 };
      this.fetchedPageMap = {};
      this.hasMore = true;
      this.total = 0;
      this.list = [];
    },
    getEffectiveParams() {
      return {
        ...this.queryForm,
        page_size: this.paginationForm.page_size,
        last_id: this.pageCursorMap[this.paginationForm.page] || 0,
      };
    },
    async ensureCursorForPage(page) {
      if (page <= 1 || this.pageCursorMap[page] !== undefined) {
        return true;
      }

      let currentPage = 1;
      while (currentPage < page) {
        if (this.pageCursorMap[currentPage + 1] !== undefined) {
          currentPage += 1;
          continue;
        }

        if (!this.hasMore) {
          return false;
        }

        const data = await this.$api.getAdLog.getAdLogList({
          ...this.queryForm,
          page_size: this.paginationForm.page_size,
          last_id: this.pageCursorMap[currentPage] || 0,
        });

        const nextList = data.data && data.data.list ? data.data.list : [];
        this.hasMore = Boolean(data.data && data.data.has_more);
        const nextLastId = data.data && data.data.last_id ? data.data.last_id : 0;

        this.fetchedPageMap[currentPage] = nextList;

        if (this.hasMore && nextList.length) {
          this.pageCursorMap[currentPage + 1] = nextLastId;
          this.total = Math.max(this.total, (currentPage + 1) * this.paginationForm.page_size);
        } else {
          this.pageCursorMap[currentPage + 1] = nextLastId || 0;
          this.total = (currentPage - 1) * this.paginationForm.page_size + nextList.length;
        }

        currentPage += 1;
      }

      return true;
    },
    async getList() {
      this.loading = true;
      try {
        const page = this.paginationForm.page;
        if (page > 1) {
          const ok = await this.ensureCursorForPage(page);
          if (!ok) {
            this.list = [];
            return;
          }
        }

        if (this.fetchedPageMap[page]) {
          this.list = this.fetchedPageMap[page];
          return;
        }

        const data = await this.$api.getAdLog.getAdLogList(this.getEffectiveParams());
        const nextList = data.data && data.data.list ? data.data.list : [];
        this.hasMore = Boolean(data.data && data.data.has_more);
        const nextLastId = data.data && data.data.last_id ? data.data.last_id : 0;
        this.fetchedPageMap[page] = nextList;
        this.list = nextList;

        if (this.hasMore && nextList.length) {
          this.pageCursorMap[page + 1] = nextLastId;
          this.total = Math.max(this.total, (page + 1) * this.paginationForm.page_size);
        } else {
          this.pageCursorMap[page + 1] = nextLastId || 0;
          this.total = (page - 1) * this.paginationForm.page_size + nextList.length;
        }
      } finally {
        this.loading = false;
      }
    },
    openDialog(userId) {
      this.queryForm = {
        ...createDefaultQueryForm(),
        user_id: userId,
      };
      this.paginationForm.page = 1;
      this.paginationForm.page_size = 20;
      this.timeRange = [];
      this.resetCursorState();
      this.getList();
      this.dialogVisible = true;
    },
    handleCurrentChange(page) {
      this.paginationForm.page = page;
      this.getList();
    },
    handleSizeChange(size) {
      this.paginationForm.page_size = size;
      this.paginationForm.page = 1;
      this.resetCursorState();
      this.getList();
    },
    handleTimeChange(value) {
      if (!value) {
        this.queryForm.start_time = "";
        this.queryForm.end_time = "";
        return;
      }
      this.queryForm.start_time = Math.floor(Number(value[0]) / 1000);
      this.queryForm.end_time = Math.floor(Number(value[1]) / 1000);
    },
    search() {
      this.paginationForm.page = 1;
      this.resetCursorState();
      this.getList();
    },
    resetSearch() {
      const userId = this.queryForm.user_id;
      this.queryForm = {
        ...createDefaultQueryForm(),
        user_id: userId,
      };
      this.paginationForm.page = 1;
      this.timeRange = [];
      this.resetCursorState();
      this.getList();
    },
  },
};
</script>

<style scoped>
.filter-grid {
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  align-items: center;
}

.filter-actions {
  display: flex;
  gap: 8px;
}

.pagination {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 16px;
}
</style>
